import { Grid, Card, Container } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import React, { useEffect, useState } from "react";
import EvaluationCard from "../Evaluation/EvaluationCard";
import { withFirebase } from "../Firebase";
import { LoadingPage } from "../LoadingPage";

const TestMenu = (props) => {
  const firebase = props.firebase;
  const lang = props.lang;

  const [evaluations, setevaluations] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    firebase
      .evaluations()
      .once("value")
      .then((snap) => {
        let evaluations = [];

        Object.keys(snap.val()).map((evaluation) => {
          evaluations.push({ ...snap.val()[evaluation], id: evaluation });
        });
        setevaluations(evaluations);
        setIsLoaded(true);
      });
  }, []);

  if (isLoaded) {
    return (
      <Container>
        <Grid
          container
          justify="center"
          alignItems="center"
          spacing={4}
          style={{
            height: "80vh",
            marginBottom: 24,
            paddingTop: 12,
          }}
        >
          {evaluations.map((evaluation, key) => (
            <Grid key={key} item lg={3} xs={12}>
              <EvaluationCard data={evaluation} lang={lang} />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  } else {
    return <LoadingPage />;
  }
};

export default withFirebase(TestMenu);
